import { cva } from '@/styled-system/css';

export const tableHeaderCellRecipe = cva({
  base: {},
  variants: {
    appearance: {
      bare: {
        borderBlockEndWidth: 'default',
        borderBlockEndStyle: 'solid',
        borderBlockEndColor: 'border.muted-alt',
      },
      horizontal: {},
      grid: {},
      zebra: {},
    },
    interactive: {
      true: {
        cursor: 'pointer',
        userSelect: 'none',
        position: 'relative',
        overflow: 'visible',

        _hover: {
          backgroundColor: 'bg.action.neutral.alt.hover',
          color: 'text.neutral',
        },

        _active: {
          backgroundColor: 'bg.action.neutral.alt.pressed',
          color: 'text.neutral',
        },
      },
      false: {},
    },
    size: {
      sm: {
        textStyle: 'body-sm-bold',
      },
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
    sticky: {
      true: {
        position: 'sticky',
        top: 0,
      },
      false: {},
    },
  },
});
